import styled, { css } from 'styled-components';

export const QuestionContainer = styled.div<{ required: boolean; error: boolean; isEn: boolean }>`
  display: flex;
  flex-direction: column;
  max-width: 1000px;
  width: 100%;
  padding: 2rem;
  background-color: #fff;
  border: 2px solid #f4f4f4;
  border-radius: 10px;

  &:last-child {
    margin-bottom: 30px;
  }

  ${(props) =>
    props.error &&
    css`
      outline: 2px solid #ff0000;
      border-radius: 10px;

      .error-message {
        color: #ff0000;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1rem;
        margin-bottom: 0.5rem;

        svg {
          margin-right: 4px;
          fill: #ff0000;
        }
      }
    `}

  .question {
    width: 100%;
    margin-bottom: 10px;

    h2 {
      text-align: left;
      color: ${(props) => props.theme.colors.tertiaryBlueText};
      font-size: medium;
      font-weight: 600;
      margin: 0;

      .question-circle {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        border-radius: 50%;
        width: 25px;
        height: 25px;
        border: 2px solid ${(props) => props.theme.colors.tertiaryBlueText};
      }

      ${(props) =>
        props.required
          ? css`
              &::after {
                content: '*';
                color: #ff0000;
              }
            `
          : props.isEn
            ? css`
                &::after {
                  content: '(optional)';
                  font-size: 1rem;
                  margin-left: 4px;
                  font-weight: 400;
                }
              `
            : css`
                &::after {
                  content: '(opcional)';
                  font-size: 1rem;
                  margin-left: 4px;
                  font-weight: 400;
                }
              `}
    }

    p {
      color: ${(props) => props.theme.colors.tertiaryBlueText}80;
      margin-top: 6px;
    }
  }

  > div {
    width: 100%;

    .titles {
      display: flex;
      justify-content: space-between;
      color: ${(props) => props.theme.colors.tertiaryBlueText}a1;
      font-weight: 600;
      font-size: 0.8rem;
    }

    ul {
      list-style: none;
      display: flex;
      flex-direction: row;
      gap: 20px;
      padding-inline-start: 0;
      flex-wrap: wrap;

      li {
        button {
          font-size: medium;
          border: 2px solid ${(props) => props.theme.colors.tertiaryBlueText}4a;
          padding: 6px 12px;
          font-weight: 600;

          cursor: pointer;
          transition: all 0.2s ease-in;
          background-color: transparent;
          display: flex;
          justify-content: center;
          align-items: center;
          color: ${(props) => props.theme.colors.tertiaryBlueText}4a;

          &:focus-visible {
            border-color: ${(props) => props.theme.colors.blue}60;
            outline: 2px solid ${(props) => props.theme.colors.blue};
            outline-offset: 2px;
          }
        }

        &:hover,
        &.selected {
          button {
            border-color: ${(props) => props.theme.colors.blue}60;
            color: ${(props) => props.theme.colors.blue};
          }
        }

        &.selected {
          button {
            background-color: ${(props) => props.theme.colors.blue}1a;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    padding: 1rem;
    .question {
      margin-bottom: 0;
    }

    > div {
      ul {
        gap: 10px;
      }
    }
  }

  @media (max-width: 522px) {
    > div {
      ul {
        gap: 6px;
      }
    }
  }
`;

export const FivePointStyles = styled.div`
  li {
    width: min-content;

    button {
      width: 100px;
      height: 100px;
      border-radius: 16px;
      margin: auto;
      color: ${(props) => props.theme.colors.darkTextPale}95 !important;
      border-color: ${(props) => props.theme.colors.darkTextPale}95 !important;

      svg {
        width: 90%;
        height: 90%;
        fill: ${(props) => props.theme.colors.darkTextPale}95;
        transition: fill 0.2s ease-in;
      }
    }

    label {
      display: block;
      width: 100%;
      text-align: center;
      font-size: 14px;
      color: ${(props) => props.theme.colors.darkTextPale}95;
      font-weight: 600;
      margin: 6px auto;
    }

    &:hover,
    &.selected {
      button {
        color: ${(props) => props.theme.colors.blue} !important;
        border-color: ${(props) => props.theme.colors.blue} !important;
      }

      svg {
        fill: ${(props) => props.theme.colors.blue};
      }
    }
  }

  @media (max-width: 768px) {
    li {
      button {
        width: 80px;
        height: 80px;
      }

      label {
        font-size: 11px;
      }
    }
  }

  @media (max-width: 510px) {
    li {
      button {
        width: 50px;
        height: 50px;
        padding: 3px 6px !important;
      }

      label {
        font-size: 10px;
      }
    }
  }
`;

export const NpsStyles = styled.div`
  li button {
    font-size: medium;
    font-weight: 600;
    width: 50px;
    height: 50px;
    border-radius: 16px;
    color: white !important;
    opacity: 0.3 !important;
    border: none !important;
  }

  li.selected,
  li:hover {
    button {
      opacity: 1 !important;
    }
  }

  @media (max-width: 768px) {
    li {
      button {
        width: 35px;
        height: 35px;
        border-radius: 10px;
      }
    }
  }

  @media (max-width: 510px) {
    li {
      button {
        width: 30px;
        height: 30px;
        border-radius: 10px;
        font-size: small;
      }
    }
  }
`;

export const CheckboxStyles = styled.div`
  ul {
    flex-wrap: wrap;
    justify-content: center;

    li button {
      width: max-content;

      @media (max-width: 600px) {
        width: 100%;
        white-space: normal;
        text-align: left;
      }
      /* height: 50px; */
      font-size: medium;
      font-weight: 600;
      border-radius: 12px;
      color: ${(props) => props.theme.colors.darkTextPale}95 !important;
      border-color: ${(props) => props.theme.colors.darkTextPale}95 !important;
    }

    li.selected {
      button {
        color: ${(props) => props.theme.colors.blue} !important;
        border-color: ${(props) => props.theme.colors.blue} !important;
      }

      svg {
        margin-right: 8px;
        background-color: ${(props) => props.theme.colors.blue}60;
        border-radius: 6px;
        padding: 2px;
        height: 24px;
        width: 24px;
      }
    }

    li.disabled {
      pointer-events: none;

      button {
        cursor: not-allowed;
        color: ${(props) => props.theme.colors.mutedText} !important;
        border-color: ${(props) => props.theme.colors.mutedText} !important;
      }
    }

    @media (max-width: 600px) {
      li {
        width: 100%;
      }
    }
  }

  .limit-message {
    margin-top: 12px;
    font-size: 1rem;
    color: ${(props) => props.theme.colors.darkTextPale};
    text-align: left;
  }
`;

export const RadioStyles = styled.div`
  ul {
    flex-wrap: wrap;
    justify-content: center;
    li {
      button {
        border-radius: 24px;
        width: max-content;
        font-size: 1.2rem;
        font-weight: 600;
        color: ${(props) => props.theme.colors.darkTextPale}95 !important;
        border-color: ${(props) => props.theme.colors.darkTextPale}95 !important;
      }

      &.selected button {
        color: ${(props) => props.theme.colors.blue} !important;
        border-color: ${(props) => props.theme.colors.blue} !important;

        &::before {
          content: '';
          width: 16px;
          height: 16px;
          display: inline-block;
          margin: auto;
          background-color: ${(props) => props.theme.colors.blue};
          border-radius: 50%;
          margin: auto 10px auto 5px;
          outline: 5px solid ${(props) => props.theme.colors.blue}60;
        }
      }
    }

    @media (max-width: 600px) {
      li {
        width: 100%;

        button {
          font-size: 0.9rem;
          white-space: normal;
          text-align: left;
          width: 100%;
        }
      }
    }
  }
`;

export const NumberSliderStyles = styled.div`
  .slider-container {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
  }

  .slider-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 200px;
    max-width: 400px;
  }

  .slider-label {
    font-size: 14px;
    font-weight: 600;
    color: ${(props) => props.theme.colors.tertiaryBlueText}80;
    min-width: 24px;
    text-align: center;

    &.min {
      text-align: right;
    }

    &.max {
      text-align: left;
    }
  }

  .slider-track {
    position: relative;
    flex: 1;
    height: 8px;
    background-color: ${(props) => props.theme.colors.tertiaryBlueText}20;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover:not(.disabled) {
      background-color: ${(props) => props.theme.colors.tertiaryBlueText}30;
    }

    &.disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }

  .slider-bar {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    background-color: ${(props) => props.theme.colors.blue};
    border-radius: 4px;
    transition: width 0.1s ease;
  }

  .slider-thumb {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 20px;
    height: 20px;
    background-color: white;
    border: 3px solid ${(props) => props.theme.colors.blue};
    border-radius: 50%;
    cursor: grab;
    transition:
      box-shadow 0.2s ease,
      transform 0.1s ease;
    z-index: 1;

    &:hover {
      box-shadow: 0 0 0 4px ${(props) => props.theme.colors.blue}30;
    }

    &.dragging {
      cursor: grabbing;
      box-shadow: 0 0 0 6px ${(props) => props.theme.colors.blue}40;
      transform: translate(-50%, -50%) scale(1.1);
    }

    &.hidden {
      opacity: 0;
      pointer-events: none;
    }

    &:focus-visible {
      outline: none;
      box-shadow: 0 0 0 4px ${(props) => props.theme.colors.blue}50;
    }
  }

  .thumb-label {
    position: absolute;
    bottom: calc(100% + 8px);
    top: auto;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${(props) => props.theme.colors.blue};
    color: white;
    font-size: 12px;
    font-weight: 600;
    padding: 4px 8px;
    border-radius: 4px;
    white-space: nowrap;

    &::after {
      content: '';
      position: absolute;
      top: 100%;
      bottom: auto;
      left: 50%;
      transform: translateX(-50%);
      border: 5px solid transparent;
      border-top-color: ${(props) => props.theme.colors.blue};
    }
  }

  .more-badge {
    padding: 4px 10px;
    border: none;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    color: ${(props) => props.theme.colors.tertiaryBlueText}80;
    background-color: ${(props) => props.theme.colors.tertiaryBlueText}15;
    cursor: pointer;
    transition: all 0.2s ease-in;

    &:hover {
      color: ${(props) => props.theme.colors.blue};
      background-color: ${(props) => props.theme.colors.blue}20;
    }

    &.selected {
      color: white;
      background-color: ${(props) => props.theme.colors.blue};
    }

    &:focus-visible {
      outline: 2px solid ${(props) => props.theme.colors.blue};
      outline-offset: 2px;
    }
  }

  @media (max-width: 768px) {
    .slider-wrapper {
      min-width: 180px;
    }

    .slider-label {
      font-size: 12px;
    }

    .slider-thumb {
      width: 18px;
      height: 18px;
    }

    .thumb-label {
      font-size: 11px;
      padding: 3px 6px;
    }

    .more-badge {
      font-size: 12px;
      padding: 3px 8px;
    }
  }

  @media (max-width: 510px) {
    .slider-container {
      gap: 12px;
    }

    .slider-wrapper {
      min-width: 150px;
      gap: 8px;
    }

    .slider-label {
      font-size: 11px;
      min-width: 20px;
    }

    .slider-track {
      height: 6px;
    }

    .slider-thumb {
      width: 16px;
      height: 16px;
      border-width: 2px;
    }

    .thumb-label {
      font-size: 10px;
      padding: 2px 5px;
    }

    .more-badge {
      font-size: 11px;
      padding: 3px 7px;
    }
  }
`;

export const TextStyles = styled.div`
  width: 100% !important;
  margin: 1rem auto;
  input {
    width: 100%;
  }

  textarea {
    min-height: 150px !important;
    resize: none;
  }

  input,
  textarea {
    background-color: #fefefe;
    border-width: 2px;
    border-color: #e1e1e1;
  }
`;
